const data = [
  {
    type: 'title',
    order: 1,
    title: 'Stuntin’ in Style',
    subtitle: 'Lakers stars Julius Randle & D’Angelo Russell show off their flair for fashion on the streets of L.A.',
    info: 'Photography by The Collaborationist<br/>Styling by Brandon Williams<br/>Interviews by Lance Fresh<br/>OCTOBER 26, 2016',
    images: [
      {
        id: 1,
        path: 'assets/images/mobile/russell_cover_mobile.jpg',
        largePath: 'assets/images/desktop/desktop_russell.jpg',
        size: {
          height: 1001,
          width: 563,
        },
        largeSize: {
          height: 1440,
          width: 2560,
        },
      },
      {
        id: 2,
        path: 'assets/images/mobile/randle_cover_mobile.jpg',
        largePath: 'assets/images/desktop/desktop_randle.jpg',
        size: {
          height: 1001,
          width: 563,
        },
        largeSize: {
          height: 1440,
          width: 2560,
        },
      },
    ],
  },
  {
    type: 'image',
    order: 2,
    path: 'assets/images/mobile/image_1.jpg',
    largePath: 'assets/images/desktop/image_1.jpg',
    largeGridColumns: 7,
    largeGridPush: 0,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 1558,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'Julius <span class="small">(left)</span>',
          items: [
            'Daniel Patrick yellow bomber',
            'Nike white and black cortez sneakers',
            'Nike socks',
            'Rag & Bone ripped denim (his own)',
            'Jewelry (his own)',
          ],
        },
        {
          title: 'D’angelo <span class="small">(right)</span>',
          items: [
            'Leather Jacket by Off-white',
            'Joyrich blue “hockey” shirt',
            'Dope paint-splattered “santa monica” denim',
            'Android Homme white low-top sneakers',
            'Joyrich black “rock teddy” bucket hat',
            'Super sunglasses',
            'Earrings (his own)',
          ],
        },
      ],
    },
  },
  {
    color: '#e24259',
    bgColor: '#fffff8',
    type: 'large-text',
    order: 3,
    largeGridColumns: 8,
    largeGridPush: 3,
    largeTopPush: 'negative-1',
    content: 'Before returning to NBA uniform wear, Lakers guard <span class="large">D’Angelo Russell</span> and forward <span class="large">Julius Randle</span> pull together the flyest game-day ensembles while chatting with B/R’s Lance Fresh about their unabashed personal style.',
  },
  {
    type: 'image',
    order: 4,
    path: 'assets/images/mobile/image_2.jpg',
    largePath: 'assets/images/desktop/image_2.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2848,
      width: 2160,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'Julius',
          items: [
            'Daniel Patrick yellow bomber',
            'Rag & Bone ripped denim (his own)',
            'Jewelry (his own)',
          ],
        },
      ],
    },
  },
  {
    type: 'image',
    order: 5,
    path: 'assets/images/mobile/image_3.jpg',
    largePath: 'assets/images/desktop/image_3.jpg',
    largeGridColumns: 7,
    largeGridPush: 0,
    largeTopPush: 'negative-1',
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 1196,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'Leather Jacket by Off-white',
            'Joyrich blue “hockey” shirt',
            'Joyrich black “rock teddy” bucket hat',
            'Super sunglasses',
            'Earrings (his own)',
          ],
        },
      ],
    },
  },
  {
    bgColor: '#fffff8',
    type: 'text',
    order: 6,
    largeGridColumns: 7,
    largeGridPush: 5,
    largeTopPush: 'negative-1',
    content: '<p class="grey"><strong>LANCE FRESH</strong> What gear do you rock harder than anyone else in the NBA?</p><p class="green"><strong>JULIUS RANDLE</strong> Bomber [jackets]. I’ve got all kinds. Nobody in the league is close, man. I step correct with that.</p><p class="green"><strong>D’ANGELO RUSSELL</strong> I have the most creative T-shirts. My T-shirts, I’m Lil Uzi with it. I wear jackets no matter the weather, and I’m gonna have a T-shirt under that. It’s gonna go hard.</p>',
  },
  {
    type: 'ad',
    order: 7,
    path: 'assets/images/advs/BBE_300x250_v2.png',
    largePath: 'assets/images/advs/BBE_300x250_v2.png',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 250,
      width: 300,
    },
    largeSize: {
      height: 250,
      width: 300,
    },
    clickThroughUrl: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19263766&PluID=0&ord=[timestamp]',
    trackingPixelUrl: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19263766&PluID=0&ord=[timestamp]&rtu=-1',
  },
  {
    type: 'inline-video',
    order: 8,
    title: '',
    subtitle: '',
    autoplay: true,
    largeGridColumns: 5,
    largeGridPush: 2,
    fps: 15,
    path: 'assets/videos/BR_Mag_Lakers_Clothes_Both_sequence_small.jpg',
    largePath: 'assets/videos/BR_Mag_Lakers_Clothes_Both.mp4',
    frames: 75,
    columns: 6,
    coverPath: 'assets/images/video/BR_Mag_Lakers_Clothes_Both_cover.jpg',
    size: {
      height: 1334,
      width: 750,
    },
  },
  {
    type: 'quote',
    bgColor: '#69d6d9',
    order: 9,
    largeGridColumns: 8,
    largeGridPush: 4,
    description: 'On style influencers',
    quotes: [
      {
        bgColor: '#69d6d9',
        direction: 'right',
        heightPercentage: 0.49,
        text: 'D-Wade helped fashion take off in the NBA. I feel like he was one of those guys who really started it, as far as the NBA guys dressing up. LeBron, obviously, too.',
        speakerImage: 'assets/images/icons/randle_icon.jpg',
      },
    ],
  },
  {
    type: 'quote',
    bgColor: '#69d6d9',
    order: 10,
    largeGridColumns: 8,
    largeGridPush: 0,
    largeTopPush: 'negative-1',
    description: 'On style influencers',
    quotes: [
      {
        bgColor: '#69d6d9',
        direction: 'left',
        heightPercentage: 0.51,
        text: 'I’ve always been a fan of [Russell] Westbrook’s mentality going into it. He doesn’t really care. I like Iman Shumpert. He has underrated swag.',
        speakerImage: 'assets/images/icons/russell_icon.jpg',
      },
    ],
  },
  {
    type: 'image',
    order: 11,
    path: 'assets/images/mobile/image_4.jpg',
    largePath: 'assets/images/desktop/image_4.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 2160,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'Julius',
          items: [
            'Daniel Patrick yellow bomber',
            'Rag & Bone ripped denim (his own)',
            'Jewelry (his own)',
          ],
        },
      ],
    },
  },
  {
    bgColor: '#fffff8',
    type: 'text',
    order: 12,
    largeGridColumns: 7,
    largeGridPush: 2,
    content: '<p class="grey">Of all the Lakers who get fly, who thinks they’re the freshest on the squad?</p><p class="green"><strong>JULIUS</strong> Swag [Nick Young], obviously! He doesn’t care, man. He’ll put on whatever he wants and walk in with all the confidence in the world. He hooped in Yeezys. You couldn’t tell him nothing.</p>',
  },
  {
    bgColor: '#fffff8',
    type: 'text',
    order: 13,
    largeGridColumns: 7,
    largeGridPush: 1,
    content: '<p class="grey">Does Swaggy P question anyone’s style on the team?</p><p class="green"><strong>JULIUS</strong> If you come in and you have some baggy jeans on, with some basketball shoes—guys like Tim Duncan, who don’t care about what they’re wearing—he’s going to get on you. But if you’re trying something, he won’t.</p>',
  },
  {
    type: 'image',
    order: 14,
    path: 'assets/images/mobile/image_5.jpg',
    largePath: 'assets/images/desktop/image_5.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 2030,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'HUF 84 red jersey ',
            'Stussy mixed-plaid l/s shirt',
            'Grungy gentleman gray striped hat',
            'Balmain denim',
          ],
        },
        {
          title: 'Julius',
          items: [
            'Green jacket by Off-White',
            'The hundreds “bad people” T-shirt',
            'Rag & Bone black denim (his own)',
            'Nike neon green/blue/white Huarache',
          ],
        },
      ],
    },
  },
  {
    type: 'image',
    order: 15,
    path: 'assets/images/mobile/quote_card_russell_1.jpg',
    largePath: 'assets/images/desktop/russell_quote_1.jpg',
    largeGridColumns: 7,
    largeGridPush: 0,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2260,
      width: 1674,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'Super sunglasses',
            'Palm Angels jean jacket',
            'Pink Dolphin red promo vase hoodie',
            'Nike black shorts',
            'Stussy red hat',
          ],
        },
      ],
    },
    quote: {
      largeGridColumns: 12,
      largeGridPush: 2,
      bgColor: '#69d6d9',
      direction: 'left',
      heightPercentage: 0.45,
      text: 'THIS IS ICY. ICY. I’D WEAR THIS ‘FIT ANYWHERE.',
      speakerImage: 'assets/images/icons/russell_icon.jpg',
    },
  },
  {
    type: 'inline-video',
    order: 16,
    title: '',
    subtitle: '',
    autoplay: true,
    largeGridColumns: 5,
    largeGridPush: 5,
    largeTopPush: 'negative-1',
    fps: 15,
    path: 'assets/videos/BR_Mag_Lakers_Dancing_sequence_small.jpg',
    largePath: 'assets/videos/BR_Mag_Lakers_Dancing.mp4',
    frames: 82,
    columns: 6,
    coverPath: 'assets/images/video/BR_Mag_Lakers_Dancing_cover.jpg',
    size: {
      height: 1334,
      width: 750,
    },
  },
  {
    bgColor: '#fffff8',
    type: 'text',
    order: 17,
    largeGridColumns: 7,
    largeGridPush: 1,
    largeTopPush: 'negative-1',
    content: '<p class="grey">Is there anyone on the Lakers you go toe-to-toe with in fashion?</p><p class="green"><strong>D’ANGELO</strong> Jordan Clarkson. He’s off the wall a little bit. I try to be off the wall at the same time. Julius, too. It’s undercover swag. We’re passionate about being in-style. So, when Jordan comes in with something I’ve never seen, I’m like, “Oh, what is that? Where’d you get that?” Jordan is the same way. We’re all trying to keep up, I guess.</p>',
  },
  {
    type: 'image',
    order: 18,
    path: 'assets/images/mobile/image_6.jpg',
    largePath: 'assets/images/desktop/image_6.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 1206,
      width: 2160,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'Leather Jacket by Off-white',
            'Joyrich blue “hockey” shirt',
            'Dope paint-splattered “santa monica” denim',
            'Joyrich black “rock teddy” bucket hat',
            'Super sunglasses',
            'Earrings (his own)',
          ],
        },
      ],
    },
  },
  {
    type: 'image',
    order: 19,
    path: 'assets/images/mobile/quote_card_randle.jpg',
    largePath: 'assets/images/desktop/randle_quote.jpg',
    largeGridColumns: 6,
    largeGridPush: 0,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 1202,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'Julius',
          items: [
            'Hotel 1711 champagne bomber',
            'Daniel patrick gray shirt',
            'Jewelry (his own)',
            'Rag & Bone jeans (his own)',
            'Nikes (his own)',
          ],
        },
      ],
    },
    quote: {
      largeGridColumns: 12,
      largeGridPush: 2,
      bgColor: '#69d6d9',
      direction: 'left',
      heightPercentage: 0.45,
      text: 'This is Lavish. This is a Lakers game ’fit, for sure.',
      speakerImage: 'assets/images/icons/randle_icon.jpg',
    },
  },
  {
    type: 'inline-video',
    order: 20,
    largeGridColumns: 5,
    largeGridPush: 5,
    largeTopPush: 'negative-2',
    title: '',
    subtitle: '',
    autoplay: true,
    fps: 15,
    path: 'assets/videos/BR_Mag_Lakers_Shoes_sequence_small.jpg',
    largePath: 'assets/videos/BR_Mag_Lakers_Shoes.mp4',
    frames: 78,
    columns: 6,
    coverPath: 'assets/images/video/BR_Mag_Lakers_Shoes_cover.jpg',
    size: {
      height: 1334,
      width: 750,
    },
  },
  {
    bgColor: '#fffff8',
    type: 'text',
    order: 21,
    largeGridColumns: 7,
    largeGridPush: 1,
    content: '<p class="grey">Do you get more fresh for nationally televised games?</p><p class="green"><strong>JULIUS</strong> Yeah, absolutely. You’re going in and you’re about to play the Golden State Warriors, you get a little more fresh, make you feel a little bit better about yourself. It’s a game-to-game process.</p>',
  },
  {
    type: 'image',
    order: 22,
    path: 'assets/images/mobile/image_7.jpg',
    largePath: 'assets/images/desktop/image_7.jpg',
    largeGridColumns: 7,
    largeGridPush: 0,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 1144,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'Leather Jacket by Off-white',
            'Joyrich blue “hockey” shirt',
            'Dope paint-splattered “santa monica” denim',
            'Joyrich black “rock teddy” bucket hat',
            'Super sunglasses',
            'Earrings (his own)',
          ],
        },
      ],
    },
  },
  {
    type: 'quote',
    bgColor: '#69d6d9',
    order: 23,
    largeGridColumns: 8,
    largeGridPush: 4,
    largeTopPush: 'negative-1',
    description: 'ON RUSSELL WESTBROOK’S FEARLESS STYLE',
    quotes: [
      {
        bgColor: '#69d6d9',
        direction: 'right',
        heightPercentage: 0.49,
        text: 'Sometimes, he’ll wear stuff a little too tight. But half the time it doesn’t really look bad, it’s just different. Some people don’t really rock with it. I feel like I can do anything, if I really wanted to.',
        speakerImage: 'assets/images/icons/russell_icon.jpg',
      },
    ],
  },
  {
    type: 'quote',
    bgColor: '#69d6d9',
    order: 24,
    largeGridColumns: 8,
    largeGridPush: 0,
    description: 'ON RUSSELL WESTBROOK’S FEARLESS STYLE',
    quotes: [
      {
        bgColor: '#69d6d9',
        direction: 'left',
        heightPercentage: 0.51,
        text: 'The ripped [white] shirt. I mean, cool. I’m not gonna hate. That’s him. But I couldn’t wear that.',
        speakerImage: 'assets/images/icons/randle_icon.jpg',
      },
    ],
  },
  {
    type: 'ad',
    order: 25,
    path: 'assets/images/advs/BBE_300x250_v2.png',
    largePath: 'assets/images/advs/BBE_300x250_v2.png',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 250,
      width: 300,
    },
    largeSize: {
      height: 250,
      width: 300,
    },
    clickThroughUrl: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19263766&PluID=0&ord=[timestamp]',
    trackingPixelUrl: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19263766&PluID=0&ord=[timestamp]&rtu=-1',
  },
  {
    type: 'image',
    order: 26,
    centerVertically: true,
    path: 'assets/images/mobile/image_8.jpg',
    largePath: 'assets/images/desktop/image_8.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 1284,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'HUF 84 red jersey ',
            'Stussy mixed-plaid l/s shirt',
            'Grungy gentleman gray striped hat',
            'G-Shock yellow watch',
          ],
        },
        {
          title: 'Julius',
          items: [
            'Off-White green jacket',
            'The hundreds “bad people” T-shirt',
          ],
        },
      ],
    },
  },
  {
    bgColor: '#fffff8',
    type: 'text',
    order: 27,
    largeGridColumns: 7,
    largeGridPush: 1,
    largeTopPush: 'negative-2',
    content: '<p class="grey">Describe the most impressive look D’Angelo has pulled off.</p><p class="green"><strong>JULIUS</strong> The Fear of God bomber with the Saint Laurent Chelsea boots. It was cold.</p><p class="grey">What’s the best look Julius has ever had?</p><p class="green"><strong>D’ANGELO</strong> We went to this movie premiere for [<span style="font-style:italic;">Jason Bourne</span>], and he had on a flannel with no collar. So, it was a dress-shirt-flannel-type thing. Ripped jeans, Chelsea boots, and I think he had a long, white undershirt under it. It was fly.</p>',
  },
  {
    type: 'image',
    order: 28,
    path: 'assets/images/mobile/image_10.jpg',
    largePath: 'assets/images/desktop/russell_quote_2.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 2160,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'D’angelo',
          items: [
            'Joyrich denim “rock teddy” bucket hat',
            'Dope red bougie crew sport “summit windbreaker”',
            'Super sunglasses',
          ],
        },
      ],
    },
  },
  {
    type: 'quote',
    bgColor: '#69d6d9',
    order: 29,
    largeGridColumns: 6,
    largeGridPush: 5,
    largeTopPush: 'negative-1',
    description: 'On making a statement',
    quotes: [
      {
        bgColor: '#69d6d9',
        direction: 'left',
        heightPercentage: 0.51,
        text: 'When it comes to swag, you have to do what people won’t do if you want the attention for it.',
        speakerImage: 'assets/images/icons/russell_icon.jpg',
      },
    ],
  },
  {
    type: 'image',
    order: 30,
    path: 'assets/images/mobile/image_9.jpg',
    largePath: 'assets/images/desktop/image_9.jpg',
    largeGridColumns: 7,
    largeGridPush: 2,
    size: {
      height: 1334,
      width: 750,
    },
    largeSize: {
      height: 2160,
      width: 1502,
    },
    credits: {
      bgColor: '#e24259',
      data: [
        {
          title: 'Julius',
          items: [
            'Hotel 1711 champagne bomber ',
            'Daniel patrick gray shirt',
            'Rag & Bone jeans (his own)',
          ],
        },
      ],
    },
  },
  {
    type: 'credits',
    order: 31,
    largeGridColumns: 6,
    largeGridPush: 4,
    images: {
      small: {
        path: 'assets/images/mobile/image_1.jpg',
        height: 1332,
        width: 750,
      },
      large: {
        path: 'assets/images/desktop/image_1.jpg',
        height: 2160,
        width: 1528,
      },
    },
    content: '<p>B/R Mag is an experimental, multiplatform digital sports magazine from Bleacher Report. It is a work in progress, and our growing team <a href="mailto:BRmag@bleacherreport.com?Subject=B/R%20Mag%20feedback">welcomes your feedback</a>.</p><p>Follow the new B/R Mag stream on the <a draggable="false" href="http://www.bleacherreport.com/mobile" rel="nofollow" target="_blank">the Team Stream app</a> and #BRmag on <a draggable="false" href="https://www.facebook.com/bleacherreport/" rel="nofollow" target="_blank">Facebook</a>, <a draggable="false" href="https://www.instagram.com/bleacherreport/" rel="nofollow" target="_blank">Instagram</a> and <a draggable="false" href="https://twitter.com/bleacherreport" rel="nofollow" target="_blank">Twitter</a> for sports storytelling worth your time, wherever you are.</p>',
    mobileTitle: 'Credits',
    mobileContent: '<p>Photography by The Collaborationist<br/>Styling by Brandon Williams<br/>Interviews by Lance Fresh</p><p>B/R Mag is an experimental, multiplatform digital sports magazine from Bleacher Report. It is a work in progress, and our growing team <a href="mailto:BRmag@bleacherreport.com?Subject=B/R%20Mag%20feedback">welcomes your feedback</a>.</p><p>Follow the new B/R Mag stream on the <a draggable="false" href="http://www.bleacherreport.com/mobile" rel="nofollow" target="_blank">the Team Stream app</a> and #BRmag on <a draggable="false" href="https://www.facebook.com/bleacherreport/" rel="nofollow" target="_blank">Facebook</a>, <a draggable="false" href="https://www.instagram.com/bleacherreport/" rel="nofollow" target="_blank">Instagram</a> and <a draggable="false" href="https://twitter.com/bleacherreport" rel="nofollow" target="_blank">Twitter</a> for sports storytelling worth your time, wherever you are.</p>',
  },
];

export default data;



/** WEBPACK FOOTER **
 ** ./assets/js/src/data/data.js
 **/